// extracted by mini-css-extract-plugin
module.exports = {"document":"PurchasableDocument_document__jv9Re"};